// Metadados dos campos de catalog.e1 — nomes de coluna do banco legado
// (`e1_xxx`) não são autoexplicativos, por isso o rótulo em português vem
// daqui. Organizado em abas, réplica funcional do form do Laravel original
// (Cadastro/Endereço/Planos/Anúncios/Financeiro/Automação), consolidado em
// menos abas pra um visual mais moderno/enxuto sem perder nenhum campo.
export const ABAS_EMPRESA = [
  {
    titulo: 'Cadastro',
    campos: [
      { nome: 'e1_nome', rotulo: 'Nome', tipo: 'text', obrigatorio: true },
      // Obrigatório (achado em auditoria 2026-09-19): vira o e-mail de
      // login do primeiro usuário admin da empresa, criado automaticamente
      // no cadastro (painel-eimovel-node v1.13.0, mesmo comportamento do
      // Laravel legado) — sem e-mail, não tem como criar esse usuário.
      { nome: 'e1_email', rotulo: 'E-mail (vira o login do admin inicial)', tipo: 'email', obrigatorio: true },
      { nome: 'e1_telefone', rotulo: 'Telefone', tipo: 'text' },
      { nome: 'e1_whats', rotulo: 'WhatsApp', tipo: 'text' },
      { nome: 'e1_site', rotulo: 'Site', tipo: 'text' },
      { nome: 'e1_cnpj', rotulo: 'CNPJ', tipo: 'text' },
      { nome: 'e1_creci', rotulo: 'CRECI', tipo: 'text' },
      { nome: 'e1_responsavel', rotulo: 'Responsável', tipo: 'text' },
      { nome: 'e1_cpfresponsavel', rotulo: 'CPF do responsável', tipo: 'text' },
      // tipo 'logo': a tela mostra o envio de arquivo (LogoEmpresa) + a URL para copiar; no banco fica a chave do R2
      { nome: 'e1_imagem', rotulo: 'Logo', tipo: 'logo' },
      { nome: 'e1_bloqueio', rotulo: 'Bloqueada', tipo: 'checkbox' },
    ],
  },
  {
    titulo: 'Endereço',
    campos: [
      { nome: 'e1_endereco', rotulo: 'Endereço', tipo: 'text' },
      { nome: 'e1_numero', rotulo: 'Número', tipo: 'text' },
      { nome: 'e1_complemento', rotulo: 'Complemento', tipo: 'text' },
      { nome: 'e1_bairro', rotulo: 'Bairro', tipo: 'text' },
      { nome: 'e1_cidade', rotulo: 'Cidade', tipo: 'text' },
      { nome: 'e1_estado', rotulo: 'Estado (UF)', tipo: 'text' },
      { nome: 'e1_latitude', rotulo: 'Latitude', tipo: 'text' },
      { nome: 'e1_longitude', rotulo: 'Longitude', tipo: 'text' },
      {
        nome: 'e1_cep',
        rotulo: 'CEP',
        tipo: 'text',
        // Auto-preenche ao sair do campo (ViaCEP, ver src/lib/cep.js) —
        // pedido por Jason 2026-09-19.
        preencheEndereco: { endereco: 'e1_endereco', bairro: 'e1_bairro', cidade: 'e1_cidade', estado: 'e1_estado' },
      },
    ],
  },
  {
    titulo: 'Planos e Anúncios',
    campos: [
      { nome: 'e1_limiteimoveis', rotulo: 'Limite de imóveis', tipo: 'number' },
      { nome: 'e1_limiteusuarios', rotulo: 'Limite de usuários', tipo: 'number' },
      { nome: 'e1_portalimobiliario', rotulo: 'Divulga em portais', tipo: 'checkbox' },
      { nome: 'e1_googleadwords', rotulo: 'Google Ads', tipo: 'checkbox' },
      { nome: 'e1_facebookads', rotulo: 'Facebook Ads', tipo: 'checkbox' },
      { nome: 'e1_whatsautomatico', rotulo: 'WhatsApp automático', tipo: 'checkbox' },
      { nome: 'e1_enviosms', rotulo: 'Envio de SMS', tipo: 'checkbox' },
      { nome: 'e1_rodiziocorretor', rotulo: 'Rodízio de corretores', tipo: 'checkbox' },
      { nome: 'e1_analytics', rotulo: 'Google Analytics (ID)', tipo: 'text' },
      { nome: 'e1_facepixel', rotulo: 'Facebook Pixel (ID)', tipo: 'text' },
      { nome: 'e1_googletag', rotulo: 'Google Tag Manager (ID)', tipo: 'text' },
      { nome: 'e1_paginaface', rotulo: 'Página do Facebook', tipo: 'text' },
      { nome: 'e1_paginayoutube', rotulo: 'Canal do YouTube', tipo: 'text' },
      { nome: 'e1_telegram', rotulo: 'Telegram', tipo: 'text' },
    ],
  },
  {
    titulo: 'Financeiro e Integração',
    campos: [
      { nome: 'e1_codfinanceiro', rotulo: 'Código financeiro', tipo: 'text' },
      { nome: 'e1_tipo', rotulo: 'Tipo', tipo: 'text' },
      { nome: 'e1_emailtrello', rotulo: 'E-mail Trello', tipo: 'email' },
      { nome: 'e1_linkagendamentosinc', rotulo: 'Link agendamento (sinc.)', tipo: 'text' },
      { nome: 'e1_linksinc', rotulo: 'Link de sincronização', tipo: 'text' },
      { nome: 'e1_enderecoxml', rotulo: 'Endereço XML integrador', tipo: 'text' },
    ],
  },
];

export const TODOS_CAMPOS = ABAS_EMPRESA.flatMap((aba) => aba.campos);

// Valor inicial de um formulário novo — booleanos explicitamente 'false'
// (texto, não boolean real — convenção do schema legado inteiro) evita
// depender de default de banco que pode não existir.
export function valoresIniciais(empresa) {
  const base = {};
  for (const campo of TODOS_CAMPOS) {
    if (campo.tipo === 'checkbox') {
      base[campo.nome] = empresa ? empresa[campo.nome] === 'true' : false;
    } else {
      base[campo.nome] = empresa?.[campo.nome] ?? '';
    }
  }
  return base;
}

// Converte de volta pro formato que a API espera (checkbox -> 'true'/'false'
// texto, número vazio -> null em vez de string vazia).
export function paraApi(valores) {
  const saida = {};
  for (const campo of TODOS_CAMPOS) {
    const valor = valores[campo.nome];
    if (campo.tipo === 'checkbox') {
      saida[campo.nome] = valor ? 'true' : 'false';
    } else if (campo.tipo === 'number') {
      saida[campo.nome] = valor === '' ? null : Number(valor);
    } else {
      saida[campo.nome] = valor === '' ? null : valor;
    }
  }
  return saida;
}

// O que o admin da imobiliária (nivel 2) pode editar na PRÓPRIA empresa — mesma
// lista que o backend aceita (painel-eimovel-node `controllers/empresa.js`
// `CAMPOS_EDITAVEIS_PELO_ADMIN`, que é quem realmente impõe: a tela só esconde).
// Fica de fora (só superadmin): bloqueio, limites de imóveis/usuários, recursos
// do plano (portais, anúncios, envio automático, SMS, rodízio) e financeiro/
// integração.
export const CAMPOS_EDITAVEIS_PELO_ADMIN = new Set([
  'e1_nome', 'e1_email', 'e1_telefone', 'e1_whats', 'e1_site', 'e1_cnpj', 'e1_creci',
  'e1_responsavel', 'e1_cpfresponsavel', 'e1_imagem',
  'e1_endereco', 'e1_numero', 'e1_complemento', 'e1_bairro', 'e1_cidade', 'e1_estado', 'e1_cep', 'e1_latitude', 'e1_longitude',
  'e1_analytics', 'e1_facepixel', 'e1_googletag', 'e1_paginaface', 'e1_paginayoutube', 'e1_telegram',
  'e1_emailtrello',
]);

const TITULOS_PARA_ADMIN = { 'Planos e Anúncios': 'Marketing', 'Financeiro e Integração': 'Integrações' };

export function abasParaAdmin() {
  return ABAS_EMPRESA.map((aba) => ({
    ...aba,
    titulo: TITULOS_PARA_ADMIN[aba.titulo] ?? aba.titulo,
    campos: aba.campos
      .filter((campo) => CAMPOS_EDITAVEIS_PELO_ADMIN.has(campo.nome))
      // o rótulo "vira o login do admin inicial" só faz sentido ao CRIAR a empresa
      .map((campo) => (campo.nome === 'e1_email' ? { ...campo, rotulo: 'E-mail' } : campo)),
  })).filter((aba) => aba.campos.length > 0);
}
